import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { Modal, Button, Text, Group } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Cubby } from "../../stores/Cubby";

const MustEnable2Fa = observer(({ cubby }: { cubby: Cubby }) => {
  const [opened, { open }] = useDisclosure(false);

  //console.log("status of cubby has 2fa", cubby.has2Fa.data);
  useEffect(() => {
    if (
      cubby.has2Fa.data === false &&
      (cubby.safeChainBalance > 100_000 || cubby.outboundLiquidity > 100_000)
    ) {
      open(); // Open the modal if conditions are met
    }
  }, [cubby.has2Fa.data, cubby.chainBalance, cubby.outboundLiquidity]);

  return (
    <Modal
      opened={opened}
      onClose={() => {}}
      closeOnClickOutside={false}
      closeOnEscape={false}
      trapFocus
      returnFocus
      title="Enable 2FA"
      centered
      withCloseButton={false}
    >
      <Text>
        Your balance is over 100,000 satoshis. As a security measure, you must
        enable 2FA to continue.
      </Text>
      <Group mt="md" style={{ justifyContent: "center" }}>
        <Button component="a" href="/otp-setup">
          Enable 2FA
        </Button>
      </Group>
    </Modal>
  );
});

export default MustEnable2Fa;
